import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CoursePurchase, PaddlePaymentRedirect, UserAccessPass } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function transaction(config) {
    const getPaddleRedirectResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(PaddlePaymentRedirect)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ parsers.taggedUnion('scope', [
            ['course', CoursePurchase],
            ['access-plan', UserAccessPass],
        ]))),
    });
    const refundResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ parsers.taggedUnion('scope', [
            ['course', CoursePurchase],
            ['access-plan', UserAccessPass],
        ]))),
    });
    return Object.freeze({
        /**
         * Get the info required to redirect from the paddle to the after pay page.
         *
         * The redirect URL will be deleted after this request.
         *
         * @param arg The arguments to the function.
         * @param arg.externalTransactionId The Paddle transaction id.
         * @returns The redirect info.
         */
        getPaddleRedirect: async ({ externalTransactionId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/paddle_transactions/${externalTransactionId}`, getPaddleRedirectResponse.v, undefined);
            return result;
        },
        /**
         * Get a transaction by id.
         *
         * @param arg The arguments to the function.
         * @param arg.transactionId The id of the transaction you want to get.
         * @returns The found transaction.
         */
        get: async ({ transactionId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/transactions/${transactionId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Refund a transaction.
         *
         * @param arg The arguments to the function.
         * @param arg.transactionId The id of the transaction you want to get.
         * @returns The found transaction.
         */
        refund: async ({ transactionId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/transactions/${transactionId}/refund`, refundResponse.v, undefined);
            return result;
        },
    });
}
